const palette = {
  'color-black': '#111111',
  'color-white': '#ffffff',
};

export default palette;
